RivalIQ.apps.LandscapeSettings.module('views', function (views) {

    'use strict';

    views.RevertDefaultBrandingModal = RivalIQ.apps.LandscapeSettings.views.DeleteCustomBrandingModal.extend({
        template: '#revertDefaultBrandingModalTemplate'
    });
});
